module.exports = __webpack_public_path__ + "static/media/favicon1.2a24a854.ico";